module.exports = __webpack_public_path__ + "static/media/programme_logo_hu.0e99691c.png";